enum SectionName {
  Doors = 'doors',
  ModelVersion = 'modelVersion',
  Options = 'options',
  Trim = 'trim',
  TruckBodyStyle = 'truckBodyStyle',
  Year = 'year'
}

export const SectionNameToLevelMap = {
  [SectionName.Doors]: 'Doors',
  [SectionName.ModelVersion]: 'Model Version',
  [SectionName.Options]: 'Options',
  [SectionName.Trim]: 'Trim',
  [SectionName.TruckBodyStyle]: 'Body Style',
  [SectionName.Year]: 'Year'
} as const;

export default SectionName;
